



















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { InventoryEventTypeEnum, ProductTypeEnum } from '@/api/types';
import {
  get_agency_sales_report_detail,
  getAgencySalesReportDetail,
} from '@/api/salesreport';
import { list_product_summaries, listProductSummaries } from '@/api/product';
import { AppModule } from '@/store/modules/app';
import {
  formatApiError,
  stringFromIDate,
  monthStringFromIDate,
  formatTime,
} from '@/utils/index';
import { productById } from '@/utils/product';

@Component({
  name: 'SalesReportDetail',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private reportId?: string;
  private data = {} as get_agency_sales_report_detail.Response;
  private loading = true;
  private products: Map<string, list_product_summaries.Product> = new Map();

  get targetMonth() {
    if (this.data && this.data.targetMonth) {
      return monthStringFromIDate(this.data.targetMonth);
    }
    return '';
  }

  get reportedAt() {
    if (this.data && this.data.reportedAt) {
      return stringFromIDate(this.data.reportedAt);
    }
    return '';
  }

  mounted() {
    this.fetchData();
  }

  private async fetchData() {
    this.loading = true;
    AppModule.StartProgress();
    try {
      // TODO: use https://github.com/kuitos/axios-extensions after https://github.com/axios/axios/pull/2207 is fixed in axios v0.19.1
      const listProductsRes = await listProductSummaries({
        types: Object.values(ProductTypeEnum).filter(
          t => (t as ProductTypeEnum) !== ProductTypeEnum.UNKNOWN_PRODUCT_TYPE // TODO: check whether correct
        ),
        includeInactive: false,
      } as list_product_summaries.Request);
      this.products = productById(listProductsRes.products);
      this.data = await getAgencySalesReportDetail({
        reportId: this.reportId,
      } as get_agency_sales_report_detail.Request);
      AppModule.StopProgress();
      this.loading = false;
    } catch (err) {
      AppModule.StopProgress();
      this.loading = false;
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Report'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private getSignedAtText(signedAt: string) {
    return formatTime(new Date(signedAt));
  }

  private getProductName(productId: string) {
    if (this.products.has(productId)) {
      return `${
        this.$i18n.locale !== 'ja' && this.products.get(productId)!.nameEn
          ? this.products.get(productId)!.nameEn
          : this.products.get(productId)!.name
      }${
        this.products.get(productId)!.fiscalYear === 0
          ? ''
          : ' [' + this.products.get(productId)!.fiscalYear + ']'
      }`;
    }
    return '';
  }
}
